import type { CreativeStrategyStatus } from "../../shared/types";

export function StrategyReplacementError({ error }: { error: CreativeStrategyStatus["pendingRevisionError"] }) {
  if (!error) return null;
  return <aside className="creative-strategy-notice" role="alert"><strong>Replacement strategy unavailable</strong><p>Approved strategy remains active. {error.message} Repair the replacement before reviewing it; its angles cannot be selected.</p></aside>;
}
